module.exports = __webpack_public_path__ + "static/media/token-bnb.cb12bed8.svg";